/**
 * Defensive client-side strip before a Forge-generated SVG is injected via
 * `dangerouslySetInnerHTML` (Build Engine Selector v1's third engine, see
 * `ForgePage.tsx`). The server (`src/build-engines/forge/`) already
 * sanitizes and schema-validates every persisted `section.forge.svg` — this
 * is belt-and-braces only, in case a stale/pre-sanitization document ever
 * reaches the client. Never a substitute for server-side sanitization.
 *
 * Strips `<script>` elements (paired and self-closing) and any `on*` event
 * handler attribute (`onclick=`, `onload=`, …). Deliberately simple regex
 * work, not a full HTML/SVG parser — the server is the real gate.
 */

const SCRIPT_ELEMENT_RE = /<script\b[^>]*>[\s\S]*?<\/script\s*>/gi;
const SCRIPT_SELF_CLOSING_RE = /<script\b[^>]*\/>/gi;
const EVENT_HANDLER_ATTR_RE = /\s+on[a-z]+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi;

export function sanitizeForgeSvg(svg: string): string {
  if (!svg) return svg;
  return svg
    .replace(SCRIPT_ELEMENT_RE, '')
    .replace(SCRIPT_SELF_CLOSING_RE, '')
    .replace(EVENT_HANDLER_ATTR_RE, '');
}
